<template>
    <div id="app">
        <v-app>
            <Appbar xl4 class="pt-5" style="width: 100%;z-index: 6;"></Appbar>
            <v-content class="pa-0" style="position: absolute;width: 100%">
                <!-- page one -->
                <v-layout style="min-height: 100vh">
                    <!-- content page one -->

                    <v-flex xs12 md6 xl4 offset-xl2>
                        <v-container pt-12 pl-0 pr-0>
                            <v-layout v-show="$vuetify.breakpoint.smAndDown" style="height: 400px;width: 100%" class="backgroundPicture"></v-layout>
                            <v-layout class="mr-0 ml-0 pa-2 mt-0" row justify-start align-center
                                      :style="$vuetify.breakpoint.smAndDown ? {'min-height':' 20vh'}:{'min-height':'80vh'}">
                                <v-flex offset-md2 class="col-12 col-md-9 col-lg-9 pr-12">
                                    <h2
                                            style="color: #1353DB;font-size: 36px;font-weight: 600;line-height: 46px;font-style: normal"
                                    >DC ONE WALLET</h2>
                                    <p
                                            class="mt-5"
                                            style="font-size: 1.125rem;color: #4F4F4F"
                                            :style="$vuetify.breakpoint.smAndDown ? {'font-size':' 14px'}:{'font-size':'1.125rem'}"
                                    >ชำระเงินง่าย รวดเร็ว และปลอดภัย ให้คุณมั่นใจ ในทุกธุรกรรมทางการเงิน</p>
                                    <v-btn
                                            class="mr-1 pa-0"
                                            style="height: auto;width: auto;border-radius: unset;background-color: white;box-shadow: none"
                                    ><img  :src="require('../assets/cta-appstore.svg')"></v-btn>
                                    <v-btn
                                            class="pa-0 mr-1"
                                            style="height: auto;width: auto;border-radius: unset;background-color: white;box-shadow: none"
                                    ><img  :src="require('../assets/cta-google-play.svg')"></v-btn>
<!--                                    <v-btn-->
<!--                                            class="pa-0 mt-1"-->
<!--                                            style="height: auto;width: auto;border-radius: unset;background-color: white;box-shadow: none"-->
<!--                                    ><img  :src="require('../assets/cta-chrome.svg')"></v-btn>-->
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-flex>
                    <!--           รูปพื้นหลัง page one-->
                    <v-flex md6
                            v-show="$vuetify.breakpoint.mdAndUp"
                            style="z-index: 7"
                            class="backgroundPicture"
                    >
                    </v-flex>
                </v-layout>
                <!-- page two -->
                <v-content class="pa-0 pt-12 backgroundColor">
                    <v-layout style="min-height: 80vh">
                        <v-container pa-0>
                            <v-layout row align-center
                                      style="min-height: 700px;margin-left: 0;margin-right: 0;justify-content: center"
                                      :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                                <!-- picture page two -->
                                <v-flex offset-xs1 offset-xl3 xl3
                                        :class="{'col-12': $vuetify.breakpoint.smAndDown}"
                                        class="col-5 pt-0 img-wrapper"
                                        v-show="$vuetify.breakpoint.mdAndUp"
                                ><v-img class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'300px'}:{'max-width':'355px'}" style="width: 355px"  :src="require('../assets/5home.png')">
                                </v-img></v-flex>
                                <!-- content page two -->
                                <v-flex xl4 class="col-6"
                                        :class="{'col-12': $vuetify.breakpoint.smAndDown}">
                                    <h1
                                            style="color: #1353DB;font-size: 4rem;text-align: center"
                                            :style="$vuetify.breakpoint.smAndDown ? {'font-size':'36px'}:{'font-size':'3rem','text-align':'start'}"
                                    >เปิดประสบการณ์ใหม่</h1>
                                    <p
                                            style="color: #4F4F4F;font-size: 1.125rem"
                                            :style="$vuetify.breakpoint.smAndDown ? {'text-align':'center'}:{'text-align':'start'}"
                                    >ทุกเรื่องการเงินกับ DC ONE WALLET ทำธุรกรรมสะดวก ง่ายๆ 3 ช่องทาง</p>
                                    <ul style="margin-top: 2rem;margin-bottom: 2rem;text-align: start"
                                        :style="$vuetify.breakpoint.smAndDown ? {'margin-left':'7rem'}:''"
                                        class="pl-0">
                                        <li style="align-items: center;color: #4F4F4F"
                                            :style="$vuetify.breakpoint.xs ? '':{'font-size':'1.3rem'}"
                                        ><span>ฝาก</span>
                                        </li>
                                        <li style="align-items: center">
                                            <span style="color: #4F4F4F"  :style="$vuetify.breakpoint.xs ? '':{'font-size':'1.3rem'}">ถอน</span>
                                        </li>
                                        <li style="align-items: center">
                                            <span style="color: #4F4F4F"  :style="$vuetify.breakpoint.xs ? '':{'font-size':'1.3rem'}">โอน</span>
                                        </li>
                                    </ul>
                                </v-flex>
                                <v-flex
                                        class="col-10 pt-0"
                                        v-show="$vuetify.breakpoint.smAndDown"
                                        justify-center
                                        style="display: flex"
                                ><img style="margin-top: 2rem;" class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'300px'}:{'max-width':'355px'}"
                                      :src="require('../assets/5home.png')">
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-layout>
                    <!-- page three -->
                    <v-layout style="min-height: 100vh;padding-top: 4em" id="deposit">
                        <v-container>
                            <v-layout row align-center
                                      :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:''">
                                <!-- content page three -->
                                <v-flex offset-xl3 xl3 offset-sm0 offset-xs0  offset-md1
                                        class="col-5"
                                        :class="{'col-12': $vuetify.breakpoint.smAndDown,'offset-xs2': $vuetify.breakpoint.smAndDown}">
                                    <h1
                                            style="color: #1353DB;font-size: 4rem;text-align: center"
                                            :style="$vuetify.breakpoint.smAndDown ? {'font-size':'1.7rem'}:{'font-size':'2.5rem','text-align':'end'}"
                                    >ฝากเงิน ได้หลายช่องทาง</h1>
                                    <p
                                            style="color: #4F4F4F;font-size: 1.125rem"
                                            :style="$vuetify.breakpoint.smAndDown ? {'text-align':'center'}:{'text-align':'end'}"
                                    >คุณสามารถฝากเงินกับ DC ONE WALLET ได้ 2 ช่องทาง คือฝากเงินบาท และ ฝาก Crypto</p>
                                </v-flex>
                                <v-flex offset-xl1 xl3 offset-md1
                                        class="col-5 pt-10"
                                        style="display: flex"
                                        justify-center
                                        :class="{'col-10': $vuetify.breakpoint.smAndDown}"
                                ><img class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'300px'}:{'max-width':'355px'}" :src="require('../assets/4deposit.png')">
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-layout>
                    <v-layout style="min-height: 100vh" id="withdraw">
                        <v-container pa-0>
                            <v-layout row align-center
                                      style="min-height: 700px;margin-left: 0;margin-right: 0;justify-content: center"
                                      :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                                <!-- picture page two -->
                                <v-flex offset-xs1 offset-xl3 xl3
                                        class="col-5 pt-0"
                                        v-show="$vuetify.breakpoint.mdAndUp"
                                        justify-center
                                        style="display: flex"
                                ><img class="inner-img" style="width: 355px"  :src="require('../assets/withdraw.png')"></v-flex>
                                <!-- content page two -->
                                <v-flex xl4
                                        class="col-6"
                                        :class="{'col-12': $vuetify.breakpoint.smAndDown}">
                                    <h1
                                            style="color: #1353DB;font-size: 4rem;text-align: center"
                                            :style="$vuetify.breakpoint.smAndDown ? {'font-size':'36px'}:{'font-size':'3rem','text-align':'start'}"
                                    >ถอนเงิน ง่าย สะดวก</h1>
                                    <p
                                            style="color: #4F4F4F;font-size: 1.125rem"
                                            :style="$vuetify.breakpoint.smAndDown ? {'text-align':'center'}:{'text-align':'start'}"
                                    >คุณสามารถถอนเงินกับ DC ONE WALLET ได้ 2 ช่องทาง คือถอนเงินบาท และ ถอน Crypto</p>
                                </v-flex>
                                <v-flex
                                        class="col-10 pt-0"
                                        v-show="$vuetify.breakpoint.smAndDown"
                                        justify-center
                                        style="display: flex"
                                ><img class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'300px'}:{'max-width':'355px'}" :src="require('../assets/5home.png')">
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-layout>
                </v-content>
                <!-- page four -->
                <v-container style="padding-top: 8rem;padding-bottom: 0px" id="transfer">
                    <v-layout row align-center
                              style="min-height: 500px"
                              :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                        <v-flex  offset-xl2 xl3 class="col-5"
                                 :class="{'col-10': $vuetify.breakpoint.smAndDown}">
                            <h3 style="font-size: 2rem;margin-bottom: 1.2rem;color: #1353DB;font-weight: 600"
                                :style="$vuetify.breakpoint.smAndDown ? {'text-align':'center'}:{'text-align':'end'}"
                            >โอนเงิน รวดเร็ว ปลอดภัย</h3>
                            <p style="font-size: 1.125rem;font-weight: 400;padding-bottom: 1.5rem!important;color: #4F4F4F"
                               :style="$vuetify.breakpoint.smAndDown ? {'text-align':'center'}:{'text-align':'end'}"
                            >เพียงเลือกโอนผ่าน Qr Code หรือ ระบุหมายเลขโทรศัพท์ ปลายทาง ก็สามารถโอนเงินได้ทันที</p>
                        </v-flex>
                        <v-flex xl4 justify-center :class="{'col-12': $vuetify.breakpoint.smAndDown}"
                                class="col-6 offset-md1" style="overflow: hidden;background-color: #f6f7f7;display: flex;padding-top: 5rem;padding-bottom: 0px">
                            <img class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'254px','height':'272px'}:{'max-width':'300px'}"
                                 :src="require('../assets/Mask Group.png')">
                        </v-flex>
                    </v-layout>
                </v-container>
                <!-- page six -->
                <v-container style="padding-top: 5rem;padding-bottom: 0px" id="QRcode">
                    <v-layout row align-center
                              style="min-height: 500px"
                              :style="$vuetify.breakpoint.smAndDown ? {'justify-content':' center'}:{'justify-content':'start'}">
                        <v-flex offset-xl2 xl4 offset-lg1
                                :class="{'col-12': $vuetify.breakpoint.smAndDown}"
                                justify-center
                                class="col-5"
                                v-show="$vuetify.breakpoint.mdAndUp"
                                style="overflow: hidden;background-color: #f6f7f7;display: flex;padding-top: 5rem;padding-bottom: 0px">
                            <img class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'254px','height':'272px'}:{'max-width':'300px'}"
                                 :src="require('../assets/Group 2796.png')">
                        </v-flex>
                        <v-flex offset-xl1 xl3 style="text-align: center"
                                class="col-5"
                                :class="{'col-12': $vuetify.breakpoint.smAndDown,'pt-12' : $vuetify.breakpoint.smAndDown}">
                            <h3 style="margin-bottom: 1.2rem;color: #1353DB"
                                :style="$vuetify.breakpoint.smAndDown ? {'font-size':'2rem'}:{'font-size':'2.5rem','text-align':'start'}"
                            >Qr Code</h3>
                            <p style="font-size: 1.125rem;font-weight: 400;padding-bottom: 1.5rem!important;color: #4F4F4F"
                               :style="$vuetify.breakpoint.smAndDown ? {'text-align':'center'}:{'text-align':'start'}"
                            >ชำระเงิน โอนเงิน และยังสามารถสร้าง Qr Code แบบระบุจำนวนเงินที่ต้องการลงไปได้อีกด้วย</p>
                        </v-flex>
                        <v-flex offset-xl2 xl4 offset-lg1
                                :class="{'col-12': $vuetify.breakpoint.smAndDown}"
                                justify-center
                                class="col-5"
                                v-show="$vuetify.breakpoint.smAndDown"
                                style="overflow: hidden;background-color: #f6f7f7;display: flex;padding-top: 5rem;padding-bottom: 0px;">
                            <img class="inner-img" :style="$vuetify.breakpoint.smAndDown ? {'max-width':'254px','height':'272px'}:{'max-width':'300px'}"
                                 :src="require('../assets/Group 2796.png')">
                        </v-flex>
                    </v-layout>
                </v-container>
                <v-layout id="API" justify-center align-center style="min-height: 300px;background-color: #F2F2F2;margin-top: 8rem">
                    <v-flex xs10 md6>
                        <v-layout row align-center justify-center>
                            <v-flex class="col-12 col-md-6">
                                <h1 style="color: #4F4F4F;font-size: 24px">API GATEWAY</h1>
                                <p style="color: #4F4F4F;font-size: 12px">ระบบมีการให้บริการ API เต็มรูปแบบ คุณสามารถใช้การซื้อขาย อัตโนมัติด้วยตนเอง ผ่าน API ของเรา</p>
                            </v-flex>
                            <v-flex class="col-8 col-md-6">
                                <v-btn dark style="background-color: #017CFF;width: 100%" class="px-12">Go to API Gateway</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <!-- page seven -->

                <!-- page eight -->
                <template>
                    <v-layout row justify-center align-center
                              style="padding-top: 8rem;padding-bottom: 8rem;background-color: #1353DB;margin-right: 0px;margin-left: 0px">
                        <h2 class="col-10"
                            style="color: white;font-weight: bolder;line-height: 46px;text-align: center"
                            :style="$vuetify.breakpoint.xs ? {'font-size':'1.8rem'}:{'font-size':'2.5rem'}"
                        >Let's start downloading!</h2>
                        <v-flex justify-center
                                class="col-12 mt-4"
                                style="display: flex;flex-wrap: wrap">
                            <v-btn class="mr-1 pa-0"
                                   style="height: auto;width: auto;border-radius: unset;background-color: #1353DB;box-shadow: none"
                            ><img  :src="require('../assets/cta-appstore.svg')"></v-btn>
                            <v-btn class="mr-1 pa-0"
                                   style="height: auto;width: auto;border-radius: unset;background-color: #1353DB;box-shadow: none"
                            ><img  :src="require('../assets/cta-google-play.svg')"></v-btn>
                            <v-btn class="pa-0"
                                   :class="{'pt-1':$vuetify.breakpoint.xs}"
                                   style="height: auto;width: auto;border-radius: unset;background-color: #1353DB;box-shadow: none"
                            ><img  :src="require('../assets/cta-chrome.svg')"></v-btn>
                        </v-flex>
                    </v-layout>
                    <Footer></Footer>
                </template>
            </v-content>
        </v-app>
    </div>
</template>

<script>
    import Footer from "../components/Footer"
    import Appbar from "../components/Appbar"
    export default {
        name: "Main",
        components: {
            Appbar,
            Footer
        },
        data: ()=>({
        }),
        created() {

        }
    }</script>

<style scoped>
    .backgroundPicture {
        background-image: url('../assets/backgroundfirst.png');
        background-size: 170%;
    }
    .backgroundColor {
        background-image: url('../assets/Group 2802.png');
        background-size: cover;
    }
    ul {
        list-style: none;
        counter-reset: item;

    }
    ul li:before {
        content: counter(item) "";
        counter-increment: item;
        border: 2px solid #6b2de3;
        font-weight: 400;
        margin-right: 1rem;
        justify-content: center;
        align-items:center;
        border-radius: 50%;
        font-size: 34px;
        color: #6b2de3;
        height: 60px;
        width: 60px;
        margin-bottom: .5rem;
        display: inline-flex;
    }
    .img-wrapper {

    }
    .inner-img {
        transition: .4s;
    }
    .inner-img:hover {
        transform: scale(1.3);
    }
</style>

